<template>
  <div>
    <a-modal v-model="visible" title="Add attendance" style="top: 20px;" @cancel="handleCancel">
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Cancel</a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleSubmit">Submit Attendance</a-button>
      </template>

      <a-form :form="form" @submit="handleSubmit">
        <div class="row">
          <div class="col-md-12 mb-2">
            <a-alert
              class="mb-3"
              message="Add absentees' roll numbers separated by commas ( , )"
              type="info"
              closable
            />

            <a-form-item label="Absentees' Roll Nos">
              <a-input
                placeholder="1,2,3,...."
                v-decorator="['roll_nos',
                {
                  rules: [{ required: true, message: 'Please input absentees roll numbers' }],
                  initialValue: absentStudentRolls
                }
                ]"
              />
            </a-form-item>
          </div>
        </div>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import moment from 'moment'
import { find } from 'lodash'

export default {
  name: 'AddAttendance',
  props: ['students', 'absentees'],
  data: function() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      visible: false,
      absentStudentRolls: '',
    }
  },
  mounted: function() {
    this.$eventBus.$on('openAttendanceAddByRollModal', this.showModal)
  },
  watch: {
    absentees: function (val) {
      let studentRolls = val.map(element => {
        let student = find(this.students, { 'student_id': element })
        if (student) return student.roll_no
      })
      this.absentStudentRolls = studentRolls.join(',')
    },
  },
  methods: {
    moment,
    showModal() {
      this.visible = true
    },

    handleCancel(e) {
      this.form.resetFields()
      this.visible = false
    },

    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          const cleanRollNos = values.roll_nos.replace(/\s/g, '')
          const rollNos = cleanRollNos.split(',').filter(element => {
            return element !== ''
          })

          let studentIds = rollNos.map(element => {
            let student = find(this.students, { 'roll_no': element })
            if (student) return student.student_id
          })

          this.$emit('studentsSelected', studentIds)
          this.visible = false
        }
      })
    },
  },
}
</script>
